import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

import * as animations from "@styles/emotion-styles/animations";
import * as dimensions from "@styles/emotion-styles/dimensions";

const contentBox = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  flex-direction: column;
  text-align: center;
`;

const rupaRedirectContentBox = css`
  ${contentBox}
  width: 90%;
  padding: 2rem 0;
  margin-bottom: 0;

  @media (max-width: ${dimensions.desktopMax}) {
    width: 90%;
  }
`;

const headingWrapper = css`
  text-align: left;
  padding: 0 0.5rem;
  width: 100%;

  @media (min-width: ${dimensions.phoneMax}) {
    text-align: center;
  }
`;

const headingWrapperWithoutPadding = css`
  text-align: left;
  width: 100%;

  @media (min-width: ${dimensions.phoneMax}) {
    text-align: center;
  }
`;

const freeText = css`
  font-weight: ${typography.weightBold};
`;

const tooltip = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  margin-right: -3rem;

  @media (max-width: ${dimensions.phoneMax}) {
    margin-right: 0;
    padding: 0.75rem 0 0.75rem 0.75rem;
  }
`;

const row = css`
  display: flex;
  width: 100%;
  margin-bottom: 1rem;
`;

const form = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
`;

const input = css`
  margin-bottom: 1rem;
  :not(:last-of-type) {
    margin-top: 0.5rem;
  }
`;

const nextButtonTooltip = css`
  width: 100%;
`;

const subTitle = css`
  padding-bottom: 0.5rem;
`;

const dividerBox = css`
  width: 100%;
  max-width: 31.5rem;
  margin: auto;
  display: flex;
  justify-content: center;
  align-self: center;
  padding: 0.5rem;
`;

const patientLink = css`
  padding-top: 1.5rem;
`;

const signInLink = css`
  margin-bottom: 1rem;
`;

const rupaRedirectSignInArrange = (theme: Theme) => css`
  ${signInLink}
  gap: ${theme.ds5.gap[200]};
`;

const peerReferralTitle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
`;

const rupaCreateAccountHeadingToSubtext = (theme: Theme) => css`
  margin-bottom: ${theme.ds5.gap[200]};
`;

const userAvatar = css`
  margin-right: 0.5rem;
`;

const fullWidth = css`
  width: 100%;
`;

const appleButton = css`
  margin-top: 1rem;
`;

const designationSearchWrapper = css`
  width: 100%;
`;

const dispensaryNameTooltipTrigger = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const tosError = (theme: Theme) => css`
  text-align: center;
  color: ${theme.danger.textBase};
  animation: ${animations.fadeIn} 0.25s ${animations.easeOutCirc};
  margin: 0.5rem 0;
  width: 100%;
  font-size: ${theme.aviaryTypography.footnote.fontSize};
  display: flex;
  align-items: center;
`;

const errorIcon = (theme: Theme) => css`
  color: ${theme.danger.textBase};
  margin-right: 0.5rem;
`;

const errorText = (theme: Theme) => css`
  color: ${theme.danger.textBase};
`;

const ctas = css`
  width: 100%;
  text-align: justify;
`;

const rupaRedirectArrange = css`
  & > * {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

const pageWithInfoPanel = css`
  display: flex;
  width: 100%;
  min-height: 100%;
`;

const formContentArea = css`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-width: 0;
  align-self: stretch;
`;

const rupaRedirectMobileCenter = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
`;

const infoPanelWrapper = css`
  width: clamp(24.5rem, 25%, 26rem);
  flex-shrink: 0;
  display: flex;
  align-items: stretch;
`;

export {
  contentBox,
  rupaRedirectContentBox,
  headingWrapper,
  headingWrapperWithoutPadding,
  freeText,
  tooltip,
  row,
  form,
  input,
  nextButtonTooltip,
  subTitle,
  dividerBox,
  patientLink,
  rupaRedirectSignInArrange,
  peerReferralTitle,
  rupaCreateAccountHeadingToSubtext,
  userAvatar,
  fullWidth,
  appleButton,
  designationSearchWrapper,
  dispensaryNameTooltipTrigger,
  tosError,
  errorIcon,
  errorText,
  ctas,
  rupaRedirectArrange,
  pageWithInfoPanel,
  formContentArea,
  rupaRedirectMobileCenter,
  infoPanelWrapper,
};
